import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,_vm._b({attrs:{"dark":"","rounded":"","depressed":""},on:{"click":_vm.click}},'v-btn',_vm.$attrs,false),[_c(VIcon,{staticClass:"mr-1",attrs:{"size":"20"}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }